import { render } from "./CardCom.vue?vue&type=template&id=300de95e&scoped=true"
import script from "./CardCom.vue?vue&type=script&lang=js"
export * from "./CardCom.vue?vue&type=script&lang=js"

import "./CardCom.vue?vue&type=style&index=0&id=300de95e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300de95e"]])

export default __exports__